import { proxy } from 'valtio'
import { apiConfig } from '../apiConfig'
import { isJa } from '../i18n/useLang'
import { getName } from '../util/getName'
import { CommonApi, ProgramGroupOption, ProgramOption } from '../../generated'
import { OptionGroup } from '../../generated/models/OptionGroup'
import { convertProgramType, DEFAULT_PROGRAM_TYPE, ProgramType } from '../ProgramType'

export const programsStore = proxy<{ items: ProgramGroupOption[] }>({
  items: [],
})

const api = new CommonApi(apiConfig)
export async function loadPrograms() {
  await api.getPrograms().then((result) => {
    programsStore.items = result
  })
}

export function getProgramsName(id?: number, defaultValue?: string, isOther?: boolean) {
  if (id === undefined) return ``
  const items: ProgramOption[] = []
  programsStore.items.forEach((p: ProgramGroupOption) =>
    p.options.forEach((p: ProgramOption) => {
      items.push(p)
    })
  )
  return getName(items, id, defaultValue, isOther)
}

export function getProgramsOptions(programs: { items: OptionGroup[] }) {
  const key = isJa() ? 'nameJa' : 'name'
  const result = programs.items.map((c) => ({
    label: c[key],
    options: c.options.map((o) => ({
      ...o,
      value: o.code,
      label: o[key],
    })),
  }))
  result.forEach((r) => {
    r.options.sort((a, b) => {
      if (a.isOther) return 1
      if (b.isOther) return -1
      if (a.label < b.label) {
        return -1
      } else if (a.label === b.label) {
        return 0
      } else {
        return 1
      }
    })
  })
  return result
}


export function getProgramType(programId: number | undefined): ProgramType {
  if (programId === undefined || programId === null) return DEFAULT_PROGRAM_TYPE
  const items: ProgramOption[] = []
  programsStore.items.forEach((p: ProgramGroupOption) =>
    p.options.forEach((p: ProgramOption) => {
      items.push(p)
    })
  )
  const program = items.find((p) => p.id === programId)
  const type = program?.programType
  if (type === undefined || type === null) {
    console.error(`getProgramType: ${programId} not found in programsStore`, items, program)
  }
  return type ? convertProgramType(type) : DEFAULT_PROGRAM_TYPE
}